module.exports = __webpack_public_path__ + "assets/montserrat-semibold.4992cdd078b4ce35216ce6347cebb636.woff2";